import api from '../api';

const BASE_URL = '/api/v2/programs';

const ProgramsAPI = {
	index: (params) => api.get(`${BASE_URL}`, { params }),
	show: (programId) => api.get(`${BASE_URL}/${programId}`),
	store: (payload) => api.post(BASE_URL, payload),
	update: (programId, payload) => api.put(`${BASE_URL}/${programId}`, payload),
	updateMainAiModel: (programId, aiModelId) =>
		api.patch(`${BASE_URL}/${programId}/update-main-ai-model`, { aiModelId }),
	destroy: (programId) => api.delete(`${BASE_URL}/${programId}`),
	requestExclusion: (programId, reason) =>
		api.patch(`${BASE_URL}/${programId}/delete-request`, { reason }),
	cancelExclusionRequest: (programId) =>
		api.patch(`${BASE_URL}/${programId}/cancel-delete-request`),
};

export default ProgramsAPI;
